var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCasesSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5486)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35 1C1.99196 1 1.64858 1.14223 1.39541 1.39541C1.14223 1.64858 1 1.99196 1 2.35V8.65C1 9.00804 1.14223 9.35142 1.39541 9.60459C1.64858 9.85777 1.99196 10 2.35 10H6.4V7.75C6.4 7.39196 6.54223 7.04858 6.79541 6.79541C7.04858 6.54223 7.39196 6.4 7.75 6.4H10V2.35C10 1.99196 9.85777 1.64858 9.60459 1.39541C9.35142 1.14223 9.00804 1 8.65 1H2.35ZM7.88185 9.60445C7.72008 9.7662 7.51987 9.88419 7.3 9.94735V7.75C7.3 7.63065 7.34741 7.51619 7.4318 7.4318C7.51619 7.34741 7.63065 7.3 7.75 7.3H9.94735C9.88419 7.51987 9.7662 7.72008 9.60445 7.88185L7.88185 9.60445ZM3.25 2.8C3.13065 2.8 3.01619 2.84741 2.9318 2.9318C2.84741 3.01619 2.8 3.13065 2.8 3.25C2.8 3.36935 2.84741 3.48381 2.9318 3.5682C3.01619 3.65259 3.13065 3.7 3.25 3.7H7.75C7.86935 3.7 7.98381 3.65259 8.0682 3.5682C8.15259 3.48381 8.2 3.36935 8.2 3.25C8.2 3.13065 8.15259 3.01619 8.0682 2.9318C7.98381 2.84741 7.86935 2.8 7.75 2.8H3.25ZM3.25 4.6C3.13065 4.6 3.01619 4.64741 2.9318 4.7318C2.84741 4.81619 2.8 4.93065 2.8 5.05C2.8 5.16935 2.84741 5.28381 2.9318 5.3682C3.01619 5.45259 3.13065 5.5 3.25 5.5H7.75C7.86935 5.5 7.98381 5.45259 8.0682 5.3682C8.15259 5.28381 8.2 5.16935 8.2 5.05C8.2 4.93065 8.15259 4.81619 8.0682 4.7318C7.98381 4.64741 7.86935 4.6 7.75 4.6H3.25ZM3.25 6.4C3.13065 6.4 3.01619 6.44741 2.9318 6.5318C2.84741 6.61619 2.8 6.73065 2.8 6.85C2.8 6.96935 2.84741 7.08381 2.9318 7.1682C3.01619 7.25259 3.13065 7.3 3.25 7.3H5.05C5.16935 7.3 5.28381 7.25259 5.3682 7.1682C5.45259 7.08381 5.5 6.96935 5.5 6.85C5.5 6.73065 5.45259 6.61619 5.3682 6.5318C5.28381 6.44741 5.16935 6.4 5.05 6.4H3.25Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCasesSelected);
export default __webpack_public_path__ + "static/media/Menu-Cases-selected.d7f0650d990e805d3d93dd552833ec34.svg";
export { ForwardRef as ReactComponent };